import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Global } from "../../global";
import { LoginService } from "../../login/login.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-pdf-aviso-teste-etilometro',
  templateUrl: './pdf-aviso-teste-etilometro.component.html'
})
export class PdfAvisoTesteEtilometroComponent {

  url = '';
  alturaTela;

  constructor(
    public global: Global,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private translate: TranslateService
  ) {
    route.params.subscribe(params => {
      let userInfo = this.loginService.getUserInfo(true);
      let lang = this.translate.currentLang || (userInfo && userInfo.idioma ? userInfo.idioma : 'pt');
      this.url = global.dominio_site + '/adm/exames/teste-sopro/' + params['id_teste'] + '/aviso-pdf/?tk=' + localStorage.getItem('token') + '&lang=' + lang;
    });
    this.alturaTela = window.screen.availHeight - 250;
  }

}



// WEBPACK FOOTER //
// ./src/app/exames/teste-sopro/pdf-aviso-teste-etilometro.component.ts